const colors = {
  'light-grey': '#E5E5E5',
  'dark-grey': '#262626',
  black: '#000000',
  white: '#ffffff',
  red: '#e30613',
  'dark-red': '#C20510',
  'burnt-red': '#390205',
  'muted-black': '#00000080',
  'muted-red': '#e3061380',
  'muted-white': '#ffffff80',
} as const

const themeNames = ['light', 'dark', 'simple', 'red', 'nasa'] as const
const colorNames = ['primary', 'secondary', 'contrast', 'hover'] as const

const themes = {
  light: {
    primary: colors.white,
    secondary: colors.black,
    contrast: colors['light-grey'],
    hover: colors['muted-black'],
  },
  dark: {
    primary: colors.black,
    secondary: colors.white,
    contrast: colors['dark-grey'],
    hover: colors['muted-white'],
  },
  simple: {
    primary: colors.black,
    secondary: colors.red,
    contrast: colors['burnt-red'],
    hover: colors['muted-red'],
  },
  red: {
    primary: colors.red,
    secondary: colors.black,
    contrast: colors['dark-red'],
    hover: colors['muted-black'],
  },
  nasa: {
    primary: colors.white,
    secondary: colors.red,
    contrast: colors['light-grey'],
    hover: colors['muted-black'],
  },
} as const satisfies Themes

export { colors, themeNames, themes }

// UTIL TYPES
type Themes = Record<
  (typeof themeNames)[number],
  Record<(typeof colorNames)[number], string>
>
